export default {
  darkGreen: '#187580',
  green: '#d7dd1a',
  olive: '#c2c600',
  violet: '#C5168C',
  darkViolet: '#9000a3',
  deepCerise: '#ca2293',
  yellow: '#ffd200',
  posYellow: '#e5b200',
  yellowGreen: '#b8e986',
  eletricViolet: '#bd10e0',

  orange: '#f2634e',
  red: '#f3614b',
  carnation: '#f45f48',
  lightRed: '#f45f48',
  crimson: '#F55D45',
  lightOlive: '#d7dd1a',

  easternBlue: '#23abba',
  lightEasternBlue: '#1F94A1',
  navyBlue: '#18a2b3',
  lightBlue: '#27c2d5',
  darkBlue: '#2a2264',
  linkNavyBlue: '#292663',
  skyBlue: '#28c4d4',
  paleBlue: '#9eaec8',
  greyBlue: '#73829b',
  veloeBlue: '#36bfd4',
  blizzardBlue: '#93E1E9',
  lightestBlue: '#f0f0f4',
  menuOptionGrey: '#5b5983',
  posGrey: '#d8d7e1',
  posGreyInfo: '#b5bbc1',

  deepPurple: '#100d49',
  charcoal: '#354762',
  darkGrey: '#8583a4',
  grey: '#c5c3d8',
  lighterGrey: '#edf0f2',
  borderGrey: '#eaebf0',
  disabledGrey: '#919394',
  lightGrey: '#a1a0b7',
  mediumGrey: '#9a98b2',
  separatorGrey: '#364762',
  paleGray: '#f1f1f7',
  paleGrayTwo: '#e9e9ef',
  paleGrayThree: '#e4e3ed',
  offWhite: '#f1f1f7',
  graySuit: '#bbbace',
  white: '#ffffff',
  darkSlateBlue: '#2a2264',
  lightGray: '#edf0f2',
  blueGray: '#b1b0c5',
  tealish: '#27c2d5',
  nearWhite: '#fafafc',
  ghostWhite: '#f8f8fb',

  lightSilver: '#c5c3d8',
  organicSilver: '#a7a6c4',
  deliveredGreen: '#6c9807'
}



// WEBPACK FOOTER //
// ./src/styles/settings/colors.js